module.exports = __webpack_public_path__ + "static/img/アセット 60@3x.4d9228b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 60@3x.png
// module id = VHN/
// module chunks = 1